module.exports = __webpack_public_path__ + "static/img/4-4.162a1a93.png";